import produce, { Draft } from "immer";
// import Debug from "debug";

import { TokenStore, PayloadStudioGetTokenSuccess } from "../types";
import { ACTIONS } from "../actions/constants";

// const debug = Debug("broadcast:reducers:studio");

const processStudio = (
  studio: TokenStore,
  draft: Draft<TokenStore>,
  payload: string
): void => {
  draft.token = payload;
};

export const tokenReducer = (
  studio = { token: null },
  { type, payload }: PayloadStudioGetTokenSuccess
): TokenStore =>
  produce(studio, (draft) => {
    switch (type) {
      case ACTIONS.STUDIO_TOKEN_FAILURE:
        break;
      case ACTIONS.STUDIO_TOKEN_SUCCESS: {
        processStudio(studio, draft, payload);
        break;
      }
      default:
        break;
    }
  });
